import {
  LEARNING_GOAL_OPTIONS,
  ONBOARDING_V3_EVENT_NAME,
  PATHWAYS_ONBOARDING_EVENT_NAME,
} from 'bundles/onboarding-common/constants';
import { QUESTION_PATH_IDS } from 'bundles/onboarding-common/constants/questionScheme';
import type { QuestionValue } from 'bundles/onboarding-common/types';

import _t from 'i18n!nls/onboarding-common';

const getLearningGoalOptionName = () => ({
  [LEARNING_GOAL_OPTIONS.LEARNING_GOAL_LAND_NEW_JOB]: _t('Start my career'),
  [LEARNING_GOAL_OPTIONS.LEARNING_GOAL_CHANGE_CAREER]: _t('Change my career'),
  [LEARNING_GOAL_OPTIONS.LEARNING_GOAL_IMPROVE_SKILLS]: _t('Grow in my current role'),
  [LEARNING_GOAL_OPTIONS.LEARNING_GOAL_PERSONAL_INTEREST]: _t('Explore topics outside of work'),
});

const isQuestionAnswered = (questionValue: QuestionValue | null | undefined) => {
  if (!questionValue || questionValue.value === null) {
    return false;
  }
  switch (questionValue.__typename) {
    case 'role-select':
    case 'role-select-advancer':
    case 'skill-select':
    case 'domain-select':
      return questionValue.value.length > 0;
    case 'job-title':
      return !!questionValue.value.id || !!questionValue.value.name || !!questionValue.value.otherText;
    case 'learning-goal':
    case 'education-level':
      return questionValue.value !== null;
    default:
      return true;
  }
};

const slugifyCustomRoleName = (name?: string): string => {
  return (name || '')
    .trim()
    .toLowerCase()
    .replace(/\s+/g, '-')
    .replace(/[^a-z0-9._-]+/g, '')
    .replace(/[^a-z0-9]+$/, '');
};

const getIdontKnowOption = () => ({
  id: 'i-dont-know',
  name: _t("I don't know"),
  type: 'UNSURE' as const,
});

/**
 * Get the target onboarding version for the user
 * @returns The target onboarding version
 */
const getTargetOnboardingVersion = (shouldShowOnboardingV3?: boolean) => {
  if (shouldShowOnboardingV3) {
    return ONBOARDING_V3_EVENT_NAME;
  }
  return PATHWAYS_ONBOARDING_EVENT_NAME;
};

const getDefaultOnboardingPathId = (onboardingV3Variant: string) => {
  if (onboardingV3Variant === 'variant1') {
    return QUESTION_PATH_IDS.defaultWithoutGoal;
  } else if (onboardingV3Variant === 'variant2') {
    return QUESTION_PATH_IDS.domainFirst;
  }

  return QUESTION_PATH_IDS.default;
};

const getFirstName = (fullName?: string) => {
  if (!fullName) {
    return '';
  }
  return fullName.trim().split(' ')[0] || '';
};

export {
  getLearningGoalOptionName,
  isQuestionAnswered,
  slugifyCustomRoleName,
  getIdontKnowOption,
  getTargetOnboardingVersion,
  getDefaultOnboardingPathId,
  getFirstName,
};
